<template>
  <header class="text-center mb-4 p-4 bg-white rounded shadow-sm">
    <h1 class="display-5 text-primary mb-2"><i class="fa-solid fa-book me-2"></i>Aplikasi Stok Bahan Ajar SITTA</h1>
    <p class="lead text-muted">Sistem Informasi Tracking dan Inventori Bahan Ajar</p>
  </header>
</template>

<script>
export default {
  name: 'StockHeader'
}
</script>

<style scoped>
/* Custom styles removed in favor of Bootstrap classes */
</style>
